export default "__VITE_ASSET__CiPZomGc__"